export default {
  edit_selection: 'Muokkaa valintaa',
};
